/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Allocation_Trial_Too_LargeInputs */

const en_error_allocation_trial_too_large = /** @type {(inputs: Error_Allocation_Trial_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This warehouse has too many open lines to try a ranking on it.`)
};

/**
* | output |
* | --- |
* | "This warehouse has too many open lines to try a ranking on it." |
*
* @param {Error_Allocation_Trial_Too_LargeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_allocation_trial_too_large = /** @type {((inputs?: Error_Allocation_Trial_Too_LargeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Allocation_Trial_Too_LargeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_allocation_trial_too_large(inputs)
});